import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { IconPlusCircle, IconMinusCircle } from '@americanexpress/dls-icons';
import Select from './Select';
import { MemberContext } from '../context';
// import Input from './Input';
import { convertFullToHalfWidth } from '../../utils/util';

const updateRowIdsDynamically = (childElems, count) => {
  const elements = JSON.parse(JSON.stringify(childElems));
  const updatedElements = elements.map((node) => {
    node.map((elem) => {
      if (elem.fieldName === 'cardNumber') {
        elem.fieldId = `accountToken-${count}`;
      }
      if (elem.fieldName === 'amount') {
        elem.fieldId = `amount-${count}`;
      }
      return elem;
    });
    return node;
  });
  return updatedElements;
};

/**
 * Card Payment component return custom component
 * @param {*} param
 */
const CardPayment = ({
  fieldId,
  fieldOptions,
  fieldDesc1,
  fieldDesc2,
  childElements,
  tableHead1,
  tableHead2,
  totalAmountText,
  filledFormData,
  handleOnChangeEvents,
  fieldValidation,
  setFormSubmissionPayload,
  formSubmissionPayload,
}) => {
  const [value, setValue] = useState('singlePayment');
  const [paymentType, setPaymentType] = useState('singlePayment');
  const [totalAmount, setTotalAmount] = useState(0);
  const [fieldAmounts, setFieldAmounts] = useState(null);
  const [rowCount, setRowCount] = useState(1);
  const copyChildElements = [[...childElements]];
  const tableElements = JSON.parse(JSON.stringify(copyChildElements));
  const [tableRow, setTableRow] = useState(updateRowIdsDynamically(tableElements, rowCount));
  // const [resetField, setResetField] = useState(false);
  const memberDetails = useContext(MemberContext);

  useEffect(() => {
    setFormSubmissionPayload({ ...formSubmissionPayload, ...{ elemId: null, isSinglePayment: value === 'singlePayment' } });
  }, []);

  useEffect(() => {
    let amount = 0;
    if (filledFormData && paymentType === 'multiplePayment') {
      Object.keys(filledFormData).map((key) => {
        if (key.includes('amount-')) {
          amount += Number(filledFormData[key]);
          setTotalAmount(amount);
        }
        return true;
      });

      // for (const key in filledFormData) {
      //   if (key.includes('amount-')) {
      //     amount += Number(filledFormData[key]);
      //   }
      // }
      // setTotalAmount(amount);
    }
  }, [filledFormData]);

  const changeHandler = (e) => {
    setValue(e.target.value);
    setPaymentType(e.target.value);
    setTableRow(updateRowIdsDynamically(tableElements, 1));
    setRowCount(1);
    setTotalAmount(0);
    setFieldAmounts(null);
    document.querySelector('#accountToken-1').value = '';
    document.querySelector('#amount-1').value = '';
    setFormSubmissionPayload({ ...formSubmissionPayload, ...{ elemId: null, isSinglePayment: e.target.value === 'singlePayment' } });
    // setResetField(true);
  };

  const handleInput = (e) => {
    const { id } = e.target;
    // const val = Number(e.target.value);
    const val = convertFullToHalfWidth(e.target.value);

    // Read all amount fields while payment type is multiple payment
    if (paymentType === 'multiplePayment') {
      let allAmountFields = JSON.parse(JSON.stringify(fieldAmounts));

      if (!allAmountFields) {
        allAmountFields = {};
        allAmountFields[id] = val;
      } else {
        Object.keys(allAmountFields).map((key) => {
          if (id === key) {
            allAmountFields[key] = val;
          } else {
            allAmountFields[id] = val;
          }
          return true;
        });
      }
      setFieldAmounts({ ...allAmountFields });

      // update total amount on each amount field update
      let amount = 0;
      Object.keys(allAmountFields).map((key) => {
        amount += Number(allAmountFields[key]);
        return true;
      });
      setTotalAmount(amount);
    } else {
      setTotalAmount(val);
    }
  };

  const addTableRow = () => {
    setRowCount(rowCount + 1);
    const elementsCopy = JSON.parse(JSON.stringify(tableElements));
    const updatedFieldIdElements = updateRowIdsDynamically(elementsCopy, rowCount + 1);
    setTableRow([...tableRow, ...updatedFieldIdElements]);
  };

  const removeTableRow = (e) => {
    e.preventDefault();
    const updatedTableRow = [...tableRow];
    updatedTableRow.pop();
    setTableRow([...updatedTableRow]);

    if (Object.keys(fieldAmounts).length > 0) {
      const allAmountFields = { ...fieldAmounts };
      delete allAmountFields[`amount-${rowCount}`];
      setFieldAmounts(allAmountFields);
      setRowCount(rowCount - 1);

      let amount = 0;
      /* eslint-disable no-restricted-syntax -- need */
      for (const key in allAmountFields) {
        if (key) {
          amount += Number(allAmountFields[key]);
        }
      }
      /* eslint-enable no-restricted-syntax -- need */
      setTotalAmount(amount);
    }
  };

  // const handleTotalAmount = (e) => {
  //   setTotalAmount(e.target.value);
  // }

  /**
   * return child element
   * based on type passed
   * @param {*} elem
   */
  const childSwitcher = (elem) => {
    switch (elem.fieldType) {
      case 'select':
        return (
          <Select
            {...elem}
            handleOnChangeEvents={handleOnChangeEvents}
            // showValueAsCardNumber={true}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div id={fieldId} className="width-full pad-2-lr">
      <div className="row">
        {
          fieldOptions.map((option) => (
            <div className="radio pad-2-lr" key={option.fieldId}>
              <input
                id={option.fieldId}
                type="radio"
                name={option.fieldName}
                value={option.value}
                checked={value === option.value}
                onChange={changeHandler}
                required={true}
              />
              <label htmlFor={option.fieldId} className="">
                {option.fieldLabel}
              </label>
            </div>
          ))
        }
      </div>
      <div className="row margin-1-b label-3"><p>{fieldDesc1}</p></div>
      {paymentType === 'multiplePayment' && <div className="row margin-1-b label-3"><p>{fieldDesc2}</p></div>}
      <div className="row">
        <div className="">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>{tableHead1}</th>
                <th>{tableHead2}</th>
                {/* {
                  paymentType === "multiplePayment" && (
                    <th className="col-md-1 border-0" onClick={addTableRow}>
                      <IconPlusCircle
                        title="additional card row add icon"
                        titleId="new-card-row-btn"
                      />
                    </th>
                  )
                } */}
              </tr>
            </thead>
            <tbody>
              {/* {
                fieldLabel.tableData.map((cell) => cell.tr && cell.tr.map((value) => (
                  <tr key={value}>{value}</tr>
                ))
                )
              } */}
              {/* <tr class="col-md-6">{childElements.map((elem) => childSwitcher(elem))}</tr>
              <tr class="col-md-4">Amount</tr> */}
              {
                tableRow.map((elem, index) => (
                  /* eslint-disable react/jsx-key -- required T */
                  <tr>
                    {
                      elem.map((childElem) => (
                        <td className="pad-0-t">
                          {
                            childElem.fieldType === 'select' ? childSwitcher(childElem)
                              : (
                                <input
                                  type={childElem.fieldType}
                                  id={childElem.fieldId}
                                  key={childElem.fieldId}
                                  name={childElem.fieldId}
                                  className="form-control"
                                  onChange={handleInput}
                                  required={fieldValidation.required}
                                />
                              )
                          }
                        </td>
                      ))
                    }
                    {
                      (index === tableRow.length - 1)
                      && paymentType === 'multiplePayment'
                      && rowCount !== memberDetails.length && (
                        (
                          <th className="col-md-1 border-0" id="addRow" onClick={addTableRow}>
                            <IconPlusCircle
                              title="additional card row add icon"
                              titleId="new-card-row-btn"
                              id="addRowBtn"
                            />
                          </th>
                        )
                      )
                    }
                    {
                      index > 0
                      && (index === tableRow.length - 1)
                      && (
                        <th className="col-md-1 border-0" id="removeRow" onClick={removeTableRow}>
                          <IconMinusCircle
                            title="additional card row remove icon"
                            titleId="remove-card-row-btn"
                            id="removeRowBtn"
                          />
                        </th>
                      )
                    }
                  </tr>
                  /* eslint-enable react/jsx-key -- required T */
                ))
              }
            </tbody>
          </table>
          {
            // paymentType === 'multiplePayment' && (
            <div className="row margin-4-t flex-align-baseline">
              <p className="col-md-2 label-3">{totalAmountText}</p>
              <input
                type="number"
                id="totalAmount"
                name="totalAmount"
                className="form-control col-md-4"
                value={totalAmount}
                // onChange={handleTotalAmount}
                required={true}
                disabled={true}
              />
              <input type="hidden" id="totalAmount" name="totalAmount" value={totalAmount} />
            </div>
            // )
          }
        </div>
      </div>
    </div>
  );
};

CardPayment.propTypes = {
  fieldId: PropTypes.string,
  isMultiSelect: PropTypes.bool,
  selectionOptions: PropTypes.objectOf(PropTypes.shape),
  fieldOptions: PropTypes.objectOf(PropTypes.shape),
  fieldDesc1: PropTypes.string,
  fieldDesc2: PropTypes.string,
  childElements: PropTypes.objectOf(PropTypes.shape),
  tableHead1: PropTypes.string,
  tableHead2: PropTypes.string,
  totalAmountText: PropTypes.string,
  submitCTAText: PropTypes.string,
  handleOnChangeEvents: PropTypes.func,
  currency: PropTypes.string,
  filledFormData: PropTypes.objectOf(PropTypes.shape),
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  setFormSubmissionPayload: PropTypes.func,
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
};

export default CardPayment;
